<template>
  <div>
    <button @click="open = !open" class="text-gray-300 sm:hidden">
      <svg-icon name="hamburger"></svg-icon>
    </button>
    <div :class="classes">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false
    }
  },

  computed: {
    classes() {
      return this.open ? 'menu_open' : 'menu_closed'
    }
  }
}
</script>

<style lang="postcss" scoped>
  @media (max-width: 640px) {
    .menu_open {
      display: block;
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      z-index: 60;
      @apply bg-gray-800 p-2;
    }

    .menu_closed {
      display: none;
    }
  }
</style>
